<template>
  <div class="drop-down-list-container" ref="customDropdown">
    <div class="drop-down-list-button"
         :class="{'active-list' : activeList}"
         @click="changeActiveList">
      <sub-paragraph :color="'light-grey'" :font-family="'Eurostile'">
        {{ activePlaceholder }}
      </sub-paragraph>
      <div class="icon-container">
        <icon-default :icon="!activeList ? 'arrow-single' : 'arrow-single-purple'"/>
      </div>

    </div>
    <transition name="fade-translate-y">
      <div class="drop-down-list-content" v-if="activeList">
        <ul class="list-content">
          <li class="list-text"
              :class="{'active-text' : activePlaceholder === info.title}"
              @click="chooseText(info, index)"
              v-for="(info, index) in infoList"
              :key="info?.id || index">
            <sub-paragraph :color="'light-grey'" :font-family="'Verdana'">
              {{info?.title || info}}
            </sub-paragraph>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>

import IconDefault from "@/components/shared/IconDefault.vue";
import SubParagraph from "@/components/shared/text/SubParagraph.vue";

export default {
  name: "SelectMain",
  components: {SubParagraph, IconDefault},
  props: {
    value: {
      type: String,
      required: true
    },
    placeholderStatic: {
      type: String,
      required: true
    },
    infoList: {
      type: Array,
      default: [
        {
          title: 'title 1',
          value: 'value 1'
        },
        {
          title: 'title 2',
          value: 'value 2'
        },
      ]
    }
  },
  data() {
    return {
      activePlaceholder: '',
      activeList: false,
      activeNumberList: false,
      isActive: false,
      timer: null
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.activePlaceholder = this.value
          ? this.value
          : this.placeholderStatic
    })
    window.addEventListener('click', this.closeOptions);
  },
  unmounted() {
    window.removeEventListener('click', this.closeOptions)
  },
  watch: {
    value() {
      if(!this.isActive) {
        this.activePlaceholder = this.value
      }
    }
  },
  methods: {

    closeOptions(event) {
      if (!this.$refs.customDropdown.contains(event.target)) {
        this.activeList = false;
      }
    },
    changeActiveList() {
      this.activeList = !this.activeList;
    },
    chooseText(text) {
      let value = text.value;
      let title = text.title;
      if(this.activePlaceholder === title) {
        value = '';
        title = this.placeholderStatic;
      }
      clearTimeout(this.timer)
      this.$emit('changeDropdownList', value)
      this.activePlaceholder = title
      this.isActive = true;
      this.changeActiveList()
      this.timer = setTimeout(() => {
        this.isActive = false
      }, 240)
    }
  }
}
</script>

<style scoped lang="scss">
.drop-down-list-container {
  position: relative;
  .icon-container {
    transition: all .3s ease;
  }
  .drop-down-list-button {
    column-gap: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: unset;
    position: relative;
    transition: all .5s ease;
    white-space: nowrap;
    height: 100%;
    &.active-list {
      .text-content {
        color: var(--color-violet) !important;
      }
      .icon-container {
        transform: rotate(90deg);
      }
    }
    .text-content {
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 1;
      line-clamp: 1;
      -webkit-box-orient: vertical;
    }
    &:hover {
      opacity: 1;
    }
  }

  .drop-down-list-content {
    border-radius: 8px;
    overflow: hidden;
    width: 100%;
    max-width: inherit;
    background-color: var(--color-white);
    z-index: 11;
    position: absolute;
    border-color: var(--color-font-alice-blue);
    border-style: solid;

    .list-content {
      display: flex;
      flex-direction: column;

      .list-text {
        white-space: nowrap;
        line-height: normal;
        cursor: pointer;
        opacity: .6;
        transition: opacity .5s ease;

        &.active-text {
          opacity: 1;
          background-color: rgba(var(--color-grey-rgba), .1);
        }

        &:hover {
          opacity: 1;
        }
      }
    }
  }
}

ul,
ol {
  text-align: left;
  list-style-type: none;
  margin: 0;
  padding: 0;
}


@media (max-width: 3024px){
  .drop-down-list-container {
    .text-content {
      font-size: 16px;
    }
    .drop-down-list-button {
      padding: 12px 0;
      column-gap: 4px;
    }

    .drop-down-list-content {
      border-width: 2px;

      .list-content {
        .list-text {
          padding: 8px;
        }
      }
    }
  }
}


@media (max-width: 1920px) {
  .drop-down-list-container {
    .text-content {
      font-size: 14px;
    }
    .drop-down-list-button {
      padding: 12px 0;
      column-gap: 6px;
    }

    .drop-down-list-content {
      border-width: 2px;

      .list-content {
        .list-text {
          padding: 4px 6px;
        }
      }
    }
  }
}


@media (max-width: 1600px) {
  .drop-down-list-container {
    .text-content {
      font-size: 12px;
    }
    .drop-down-list-button {
      column-gap: 0;
    }

    .drop-down-list-content {
      border-width: 2px;

      .list-content {
        .list-text {
          padding: 4px 6px;
        }
      }
    }
  }
}
@media (max-height: 800px) {
  .drop-down-list-container {
    .text-content {
      font-size: 10px;
    }
    .drop-down-list-button {
      padding: 12px 0;
      column-gap: 4px;
    }

    .drop-down-list-content {
      border-width: 2px;
      .list-content {
        .list-text {
          padding: 4px 6px;
        }
      }
    }
  }
}

@media (max-width: 1400px) and (min-height: 801px) {
  .drop-down-list-container {
    .text-content {
      font-size: 12px;
    }
    .drop-down-list-button {
      column-gap: 0;
    }

    .drop-down-list-content {
      border-width: 2px;

      .list-content {
        .list-text {
          padding: 4px 6px;
        }
      }
    }
  }
}

@media (max-width: 1133px) {
  .drop-down-list-container {
    .text-content {
      font-size: 10px;
    }
    .drop-down-list-button {
      padding: 12px 0;
      column-gap: 4px;
    }

    .drop-down-list-content {
      border-width: 2px;
      .list-content {
        .list-text {
          padding: 4px 6px;
        }
      }
    }
  }
}

@media (max-width: 769px) {
  .drop-down-list-container {
    .text-content {
      font-size: 12px;
    }
    .drop-down-list-button {
      padding: 12px 0;
      column-gap: 4px;
    }

    .drop-down-list-content {
      border-width: 2px;
      .list-content {
        .list-text {
          padding: 4px 6px;
        }
      }
    }
  }
}

@media (max-width: 769px)  and (min-height: 720px) and (max-height: 1000px) {
  //iPhone Plus
}
@media (min-height: 600px) and (max-height: 630px){
  //для экранов 8 плюс
}

@media (max-width: 375px){
  //iPhone 8
}


@media (max-width: 375px) and (min-height: 630px) {
  //iPhone X
}


@media (max-width: 320px) {
  //iPhone SE
}

@media (min-width: 3025px) {

  .drop-down-list-container {
    .text-content {
      font-size: 28px;
    }
    .drop-down-list-button {
      padding: 12px 0;
      column-gap: 12px;
    }

    .drop-down-list-content {
      border-width: 2px;

      .list-content {
        .list-text {
          padding: 8px 16px;
        }
      }
    }
  }

}
</style>


